module.exports = require("./logBuilder");